import { render, staticRenderFns } from "./TabPackage.vue?vue&type=template&id=03dc5fe9&scoped=true&"
import script from "./TabPackage.vue?vue&type=script&lang=js&"
export * from "./TabPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dc5fe9",
  null
  
)

export default component.exports